(function () {
    'use strict';

    angular
        .module('salesflare')
        .controller('ContactsListController', ContactsListController);

    function ContactsListController($scope, $timeout, $mdMedia, $state, $mdSidenav, contactsService, $mdDialog, $exceptionHandler, $transitions, utils, usersettings, filterService, bulkService, email, helperFunctionsService, sortService, workflowService, $translate, $sce, $sanitize) {

        const types = {
            CUSTOMERS: 'customer',
            MY_CONTACTS: 'mycontacts'
        };

        $scope.type.current = $state.current.name.includes(types.CUSTOMERS) ? types.CUSTOMERS : types.MY_CONTACTS;
        const currentTypeState = $scope.type.current === types.CUSTOMERS ? 'contacts.customers' : 'contacts.my';
        const entityCountObject = {
            viewTotalCount: 0,
            viewCurrentCount: 0,
            selectedCount: 0,
            canEditCount: 0,
            option: '',
            entity: 'contacts',
            entity_singular: 'contact',
            string: ''
        };
        let optimisticallyRemovedContactsCount = 0;

        $scope.bulk.allSelected = false;
        $scope.$mdMedia = $mdMedia;
        $scope.isContactFilterApplied = filterService.isContactFilterApplied;
        $scope.emptyStateTextCustomers = $translate.instant('Add contacts to accounts to see them appear here.');
        $scope.emptyStateTextFlashlight = $translate.instant('No contacts found. Please connect a more active email account.');
        $scope.emptyStateTextCoffee = $translate.instant('No contacts left. Create a new contact to make it appear here.');
        $scope.emptyStateTextSyncing = $translate.instant('Salesflare is synchronizing. Contacts will appear here shortly.');
        $scope.noContactsFoundText = $translate.instant('No contacts found.');

        /**
         * Returns sanitized and trusted HTML for "No contacts match this filter" with link.
         * Key uses normal quotes so lookup matches translation files after JSON parse.
         *
         * @returns {Object} Trusted HTML for ng-bind-html
         */
        $scope.getNoContactsMatchFilterHtml = function () {
            const raw = $translate.instant('No contacts match <a href="">this filter</a>.');
            return $sce.trustAsHtml($sanitize(raw));
        };

        /**
         * Returns sanitized and trusted HTML for "No customers match this filter" with link.
         *
         * @returns {Object} Trusted HTML for ng-bind-html
         */
        $scope.getNoCustomersMatchFilterHtml = function () {
            const raw = $translate.instant('No customers match <a href="">this filter</a>.');
            return $sce.trustAsHtml($sanitize(raw));
        };

        /**
         * Returns sanitized and trusted HTML for "Please update the filters to continue" with link.
         *
         * @returns {Object} Trusted HTML for ng-bind-html
         */
        $scope.getPleaseUpdateFiltersHtml = function () {
            const raw = $translate.instant('Please update <a href="">the filters</a> to continue.');
            return $sce.trustAsHtml($sanitize(raw));
        };

        /**
         * Delegates clicks on empty-state links to setFilters (link is inside ng-bind-html).
         *
         * @param {Object} $event - Click event
         */
        $scope.handleEmptyStateFilterClick = function ($event) {
            if ($event.target.tagName === 'A') {
                $event.preventDefault();
                if (angular.isFunction($scope.setFilters)) {
                    $scope.setFilters($event);
                }
            }
        };

        $scope.getContactsHeaderText = function (topIndex) {
            if (!$scope.contacts || !$scope.contacts.items || !$scope.contacts.items[topIndex]) {
                return '';
            }

            const isNew = $scope.contacts.items[topIndex].not_viewed === true;
            return isNew ? $translate.instant('New contacts') : $translate.instant('Existing contacts');
        };

        // Virtual repeat + infinite scroll object that angular material uses
        $scope.contacts = {
            toLoad: 0,
            numLoaded: 0,
            items: [],
            topIndex: 0,

            getItemAtIndex: function (index) {

                if (index > this.numLoaded) {
                    this.fetchMoreItems(index);

                    return null;
                }

                return this.items[index];
            },

            getLength: function () {

                if (this.items.length < this.numLoaded) {
                    return this.items.length;
                }

                return this.numLoaded + 20;
            },

            fetchMoreItems: function (index) {

                if (this.toLoad < index) {
                    this.toLoad += 20;

                    const boundFirstResponseHandler = angular.bind(this, contactsResponse);
                    const boundSecondResponseHandler = angular.bind(this, function (response) {

                        this.items = [...this.items, ...response.data];
                        this.numLoaded = this.toLoad;

                        if ($scope.bulk.allSelected) {
                            return setSelectedOnAllContacts();
                        }
                    });

                    let filterRules;
                    let putNewContactsFirst;

                    // Do not filter or put new first when searching
                    if ($scope.searchObject.getSearch()) {
                        filterRules = [];
                        putNewContactsFirst = false;
                    }
                    else {
                        filterRules = [...filterService.getFilter('contact'), ...filterService.getPredefinedFilters('person')[$scope.type.current]];
                        putNewContactsFirst = !filterService.isContactFilterApplied();
                    }

                    const filterGetOptions = {
                        search: $scope.searchObject.getSearch(),
                        filterRules,
                        limit: this.items.length === 0 ? this.toLoad : 20,
                        // Keep pagination stable after optimistic removals by compensating the offset.
                        offset: this.items.length === 0 ? optimisticallyRemovedContactsCount : this.numLoaded + optimisticallyRemovedContactsCount,
                        orderBy: sortService.getCurrentSortOption('contact').order_by,
                        putNewFirst: putNewContactsFirst,
                        includeCount: false
                    };

                    if (this.items.length === 0) {
                        contactsService.filterGet(filterGetOptions).then(boundFirstResponseHandler, handleServerError, boundFirstResponseHandler);

                        // Do count calls after data calls as we want the data asap
                        // And only do this on initial load as the count doesn't change when loading more items
                        fetchCounts();
                        return;
                    }

                    return contactsService.filterGet(filterGetOptions).then(boundSecondResponseHandler, handleServerError, boundSecondResponseHandler);
                }
            },

            // Forces reset of object
            reload: function () {

                $scope.bulk.showBulkToolbar = false;
                $scope.bulk.allSelected = false;

                this.toLoad = 0;
                this.numLoaded = 0;
                this.items = [];
                this.doneLoading = false;
                this.topIndex = 0;
                optimisticallyRemovedContactsCount = 0;
            }
        };

        function contactsResponse(response) {

            // Do not assign items to the model if we are currently searching and the response of the call was
            // not made with the same search string as the search string we currently have in our model.
            // This is done to prevent the full contacts list from showing when the call takes longer and the user
            // searches for something before the initial contacts call ended.
            if ($scope.searchObject.getSearch() && (angular.isUndefined(response.config.params.search) || response.config.params.search !== $scope.searchObject.getSearch())) {
                return;
            }

            const self = this;
            response.data = response.data.map(function (newContact) {

                const matched = self.items.find(function (item) {

                    return item.id === newContact.id;
                });

                if (matched) {
                    newContact.selected = matched.selected;
                }

                return newContact;
            });

            this.items = response.data;
            this.numLoaded = this.toLoad;
            this.doneLoading = true;

            if ($scope.bulk.allSelected) {
                setSelectedOnAllContacts();
            }

            $scope.sideNavObject.showSideNav = !(this.items.length === 0 && !$scope.selectedPerson.id);

            if (this.items.length > 0 && $mdMedia('gt-md') && $state.is(currentTypeState) && !$scope.selectedPerson.id) {
                return $scope.goToContact(response.data[0].id);
            }
        }

        function fetchCounts() {

            let filterRules;
            let defaultFilterRules;

            // Do not filter or put new first when searching
            if ($scope.searchObject.getSearch()) {
                filterRules = [];
                defaultFilterRules = [];
            }
            else {
                defaultFilterRules = filterService.getPredefinedFilters('person')[$scope.type.current];
                filterRules = [...filterService.getFilter('contact'), ...defaultFilterRules];
            }

            const totalCountOptions = {
                filterRules: defaultFilterRules,
                returnCountOnly: true
            };
            contactsService.filterGet(totalCountOptions).then(function (response) {

                return countResponseHandler(response, 'totalCount');
            }, handleServerError, function (response) {

                return countResponseHandler(response, 'totalCount');
            });

            const canEditCountOptions = {
                filterRules: [...filterRules, { id: 'contact.can_edit', operator: 'equal', value: [true] }],
                search: $scope.searchObject.getSearch(),
                returnCountOnly: true
            };
            contactsService.filterGet(canEditCountOptions).then(function (response) {

                return countResponseHandler(response, 'canEditCount');
            }, handleServerError, function (response) {

                return countResponseHandler(response, 'canEditCount');
            });

            if ($scope.searchObject.getSearch() || $scope.isContactFilterApplied()) {
                const currentCountOptions = {
                    filterRules,
                    search: $scope.searchObject.getSearch(),
                    returnCountOnly: true
                };
                contactsService.filterGet(currentCountOptions).then(function (response) {

                    return countResponseHandler(response, 'currentCount');
                }, handleServerError, function (response) {

                    return countResponseHandler(response, 'currentCount');
                });
            }
            else {
                // If we don't do a call for the current count, we need to reset it. Otherwise it will never update.
                entityCountObject.viewCurrentCount = 0;
            }
        }

        function countResponseHandler(response, type) {

            if (angular.isDefined(response.headers()['x-result-count'])) {
                entityCountObject.option = angular.isDefined($scope.searchObject.getSearch()) && $scope.searchObject.getSearch() !== '' ? 'search' :  ($scope.isContactFilterApplied() ? 'filter' : '');
                entityCountObject.sortString = sortService.getCurrentSortOption('contact').translated_sort_string;

                if (type === 'totalCount') {
                    entityCountObject.viewTotalCount = Number.parseInt(response.headers()['x-result-count']);
                }

                if (type === 'currentCount') {
                    entityCountObject.viewCurrentCount = Number.parseInt(response.headers()['x-result-count']);
                }

                if (type === 'canEditCount') {
                    entityCountObject.canEditCount = Number.parseInt(response.headers()['x-result-count']);
                }

                entityCountObject.string = utils.getEntityCountString(entityCountObject);
            }
        }

        $scope.getEntityCountString = function () {

            return utils.getEntityCountString(entityCountObject);
        };


        $scope.goToContact = function (id) {

            if (id) {
                if ($mdMedia('md')) {
                    $mdSidenav('right').toggle();
                }

                $scope.selectedPerson.id = id;

                const goState = currentTypeState + '.contact';

                return $state.go(goState, { id });
            }
        };

        $scope.callPerson = helperFunctionsService.callPerson;

        //// bulk stuff
        $scope.bulk.bulkQuickActions = [];

        $scope.bulk.bulkQuickActions.splice(0, 0, {
            icon: 'sf-icon-delete',
            handler: function () {

                const count = entityCountObject.selectedCount;
                let deleteText;
                if (count === 1) {
                    deleteText = $translate.instant('You\'re about to delete 1 contact.');
                }
                else {
                    deleteText = $translate.instant('You\'re about to delete {{count}} contacts.', {
                        count
                    });
                }

                const confirm = $mdDialog.confirm()
                    .clickOutsideToClose(true)
                    .escapeToClose(true)
                    .title($translate.instant('Warning!'))
                    .htmlContent(`
                        <p>
                            ${deleteText}
                            <br>
                            ${$translate.instant('Are you sure you want to do this?')}
                        </p>
                    `)
                    .ok($translate.instant('I\'m sure'))
                    .cancel($translate.instant('cancel'));

                return $mdDialog.show(confirm).then(function () {

                    return bulkService.deleteContacts(getBulkOptions())
                        .then(function () {

                            return $state.reload();
                        })
                        .catch(function (err) {

                            $exceptionHandler(err);

                            return utils.showErrorToast();
                        });
                });
            },
            config: {
                toolTip: {
                    content: function () {
                        return $translate.instant('Delete');
                    }
                }
            }
        }, {
            icon: 'sf-icon-edit',
            handler: function () {

                return $state.go('bulkEditContact', { options: getBulkOptions() });
            },
            config: {
                toolTip: {
                    content: function () {
                        return $translate.instant('Edit');
                    }
                }
            }
        });

        // Find email requires an account context so it doesn't make sense to allow this for my contacts.
        // It will appear during search however since we have a mix of types then.
        toggleBulkFindEmail({ show: true, type: $scope.type.current });

        // Returns options object with either the ids selected or the filter when all selected or searching
        function getBulkOptions(getUIFilterObject) {

            if ($scope.bulk.allSelected) {
                if ($scope.searchObject.getSearch()) {
                    return {
                        condition: 'AND',
                        rules: [],
                        search: $scope.searchObject.getSearch()
                    };
                }

                return {
                    condition: 'AND',
                    rules: [...filterService.getFilter('contact', { raw: !!getUIFilterObject }), ...filterService.getPredefinedFilters('person')[$scope.type.current]]
                };
            }

            return {
                condition: 'AND',
                rules: [{
                    id: 'contact.id',
                    operator: 'in',
                    value: getSelectedContactIds()
                }]
            };
        }

        function getSelectedContactIds() {

            return $scope.contacts.items.filter(function (contact) {

                return contact.selected;
            }).map(function (contact) {

                return contact.id;
            });
        }

        function removeSelectedContactsFromList(selectedContactIds) {

            if (!selectedContactIds || selectedContactIds.length === 0) {
                return;
            }

            const selectedById = {};
            selectedContactIds.forEach(function (id) {

                selectedById[id] = true;
            });

            const previousLength = $scope.contacts.items.length;
            $scope.contacts.items = $scope.contacts.items.filter(function (contact) {

                return !selectedById[contact.id];
            });

            const removedCount = previousLength - $scope.contacts.items.length;
            if (removedCount === 0) {
                return;
            }

            optimisticallyRemovedContactsCount += removedCount;
            $scope.contacts.numLoaded = Math.max(0, $scope.contacts.numLoaded - removedCount);
            $scope.contacts.toLoad = Math.max(0, $scope.contacts.toLoad - removedCount);
            $scope.bulk.showBulkToolbar = false;
            $scope.bulk.allSelected = false;
            entityCountObject.selectedCount = 0;
            entityCountObject.string = utils.getEntityCountString(entityCountObject);

            if ($scope.selectedPerson.id && selectedById[$scope.selectedPerson.id]) {
                const fallbackContactId = $scope.contacts.items[0] && $scope.contacts.items[0].id;
                delete $scope.selectedPerson.id;

                if (fallbackContactId && $mdMedia('gt-md') && $state.includes(currentTypeState)) {
                    $scope.goToContact(fallbackContactId);
                }
                else if (!fallbackContactId && $state.includes(currentTypeState + '.contact')) {
                    $state.go(currentTypeState);
                }
            }

            $scope.sideNavObject.showSideNav = !($scope.contacts.items.length === 0 && !$scope.selectedPerson.id);
        }

        $scope.bulk.onSelectAll = function ($event) {

            $scope.bulk.allSelected = $event.allSelected;

            if ($scope.bulk.allSelected) {
                entityCountObject.selectedCount = entityCountObject.canEditCount;
                entityCountObject.string = utils.getEntityCountString(entityCountObject);
            }
            else {
                $scope.bulk.showBulkToolbar = false;
                entityCountObject.selectedCount = 0;
                entityCountObject.string = utils.getEntityCountString(entityCountObject);
            }

            return setSelectedOnAllContacts();
        };

        $scope.checkShowBulkToolbar = function () {

            // Next tick so if a `selected` value needs to be updated it does that first before our check
            return $timeout(function () {

                $scope.bulk.showBulkToolbar = $scope.contacts.items.find(function (contact) {

                    return contact.selected;
                });

                $scope.bulk.allSelected = $scope.contacts.items.every(function (contact) {

                    return contact.selected;
                });

                if ($scope.bulk.showBulkToolbar) {
                    const selectedContacts = $scope.contacts.items.filter(function (contact) {

                        return contact.selected;
                    });

                    if ($scope.bulk.allSelected) {
                        entityCountObject.selectedCount = entityCountObject.canEditCount;
                    }
                    else {
                        entityCountObject.selectedCount = selectedContacts.length;
                    }

                    entityCountObject.string = utils.getEntityCountString(entityCountObject);
                }
                else {
                    entityCountObject.selectedCount = 0;
                    entityCountObject.string = utils.getEntityCountString(entityCountObject);
                }
            });
        };

        $scope.selectContact = function (contact) {

            if (contact.can_edit === false) {
                return;
            }

            contact.selected = true;

            return $scope.checkShowBulkToolbar();
        };
        //// end bulk stuff

        $scope.$watch(function () {

            return $mdMedia('gt-md');
        }, function (newValue, oldValue) {

            if (newValue && newValue !== oldValue && !$scope.selectedPerson.id) {
                return $scope.goToContact($scope.contacts.items[0].id);
            }

            return $scope.goToContact($scope.selectedPerson.id);
        });


        $scope.$watch(function () {

            return $mdMedia('gt-sm');
        }, function (newValue, oldValue) {

            if (oldValue) {
                $mdSidenav('right').close();
            }
        });

        $scope.$on('get', get);

        // This only triggers for classic filters
        $scope.$on('csv', function () {

            // Delete put_new_first property to ensure we always export alphabetically
            const filters = angular.copy(filterService.filters.contacts);
            delete filters.put_new_first;

            return contactsService.get($scope.searchObject.getSearch(), filters, 100000, 0, sortService.getCurrentSortOption('contact').order_by, true, $scope.type.current === types.CUSTOMERS, $scope.type.current === types.MY_CONTACTS);
        });

        // This only triggers for classic filters
        $scope.$on('excel', function () {

            // Delete put_new_first property to ensure we always export alphabetically
            const filters = angular.copy(filterService.filters.contacts);
            delete filters.put_new_first;

            return contactsService.get($scope.searchObject.getSearch(), filters, 100000, 0, sortService.getCurrentSortOption('contact').order_by, false, $scope.type.current === types.CUSTOMERS, $scope.type.current === types.MY_CONTACTS, true);
        });

        $scope.goToAccount = function (account) {

            if ($mdMedia('gt-sm')) {
                return $state.go('accounts.account.feed', { id: account.id, accountsId: account.id, name: account.name });
            }

            return $state.go('accounts.account.info', { id: account.id, name: account.name });
        };

        $scope.mailto = email.mailto;

        // If you use $scope.$destroy event and sign out the bearer token isn't available anymore therefore we use $rootScope $stateChangeStart event
        const removeStartTransitionHook = $transitions.onStart({}, (transition) => {

            const fromState = transition.from();
            const toState = transition.to();

            if (fromState.name && toState.name && fromState.name.includes(currentTypeState) && !toState.name.includes(currentTypeState)) {
                removeStartTransitionHook();

                if (!filterService.isContactFilterApplied()) {
                    if ($scope.type.current === types.CUSTOMERS) {
                        usersettings.setLastVisitedCustomersToNow().then(function () {

                            if ($scope.notViewedContacts) {
                                $scope.notViewedContacts.customers.amount_new = 0;
                            }
                        });
                    }
                    else if ($scope.type.current === types.MY_CONTACTS) {
                        usersettings.setLastVisitedMyContactsToNow().then(function () {

                            if ($scope.notViewedContacts) {
                                $scope.notViewedContacts.my_contacts.amount_new = 0;
                            }
                        });
                    }
                }
            }
        });

        $scope.$on('contact:account_created', function (event, person) {

            $scope.contacts.items = $scope.contacts.items.map(function (contact) {

                if (contact.id === person.id) {
                    if (!contact.account) {
                        if (contact.not_viewed) {
                            if ($scope.notViewedContacts.my_contacts.amount_new > 0) {
                                $scope.notViewedContacts.my_contacts.amount_new = $scope.notViewedContacts.my_contacts.amount_new - 1;
                            }
                        }

                        $scope.notViewedContacts.customers.amount_new += 1;
                    }

                    contact.account = person.account;
                }

                return contact;
            });
        });

        $scope.$watch('searchMode', (newValue, oldValue) => {

            if (newValue === oldValue) {
                return;
            }

            toggleBulkFindEmail({ show: newValue });
        });

        function get() {

            return $scope.contacts.reload();
        }

        function setSelectedOnAllContacts() {

            $scope.contacts.items.forEach(function (contact) {

                contact.selected = $scope.bulk.allSelected ? contact.can_edit : false;
            });
        }

        function handleServerError(response) {

            if (response.config.method === 'HEAD') {

                return;
            }

            $scope.contacts.numLoaded = $scope.contacts.toLoad;
            $scope.contacts.doneLoading = true;

            if (response && (response.status === 422 || response.status === 402)) {

                if (response.data.filter) {

                    const selectedRules = filterService.flatten(filterService.getFilter('contact', { raw: true }));
                    const hydratedRules = filterService.flatten(response.data.filter.rules);

                    const rulesToApply = filterService.intersectAndEnrich(selectedRules, hydratedRules);

                    $scope.filters = filterService.setFilter('contact', rulesToApply);

                    $scope.handleServerError($scope.filters);
                }
            }
        }

        function toggleBulkFindEmail({ show, type }) {

            if (!show) {
                $scope.bulk.bulkMenuItems = [];
                return;
            }

            if (type === types.MY_CONTACTS) {
                $scope.bulk.bulkMenuItems = [
                    {
                        label: $translate.instant('Create accounts for contacts'),
                        handler: function () {

                            const confirm = $mdDialog.confirm()
                                .clickOutsideToClose(true)
                                .escapeToClose(true)
                                .title($translate.instant('Are you sure?'))
                                .content($translate.instant('Create accounts for {{count}} contacts', {
                                    count: entityCountObject.selectedCount
                                }))
                                .ok($translate.instant('I\'m sure'))
                                .cancel($translate.instant('cancel'));

                            return $mdDialog.show(confirm).then(function () {

                                // When all contacts are selected via the server-side filter, only a
                                // small page of contacts is loaded in memory. Using removeSelectedContactsFromList
                                // would set optimisticallyRemovedContactsCount to that small number,
                                // causing the virtual scroll to refetch from a low offset and bring
                                // the same contacts back before the server finishes processing them.
                                // Instead, set the offset to the full selected count so the virtual
                                // scroll skips past all of them.
                                if ($scope.bulk.allSelected) {
                                    const totalSelected = entityCountObject.selectedCount;

                                    return bulkService.createAccountsForContacts(getBulkOptions())
                                        .then(function () {

                                            optimisticallyRemovedContactsCount += totalSelected;
                                            $scope.contacts.items = [];
                                            $scope.contacts.numLoaded = 0;
                                            $scope.contacts.toLoad = 0;
                                            $scope.bulk.showBulkToolbar = false;
                                            $scope.bulk.allSelected = false;
                                            entityCountObject.selectedCount = 0;
                                            entityCountObject.string = utils.getEntityCountString(entityCountObject);

                                            if ($scope.selectedPerson.id) {
                                                delete $scope.selectedPerson.id;

                                                if ($state.includes(currentTypeState + '.contact')) {
                                                    $state.go(currentTypeState);
                                                }
                                            }

                                            $scope.sideNavObject.showSideNav = false;
                                        })
                                        .catch(function (err) {

                                            $exceptionHandler(err);

                                            return utils.showErrorToast();
                                        });
                                }

                                const selectedContactIds = getSelectedContactIds();

                                return bulkService.createAccountsForContacts(getBulkOptions())
                                    .then(function () {

                                        removeSelectedContactsFromList(selectedContactIds);
                                    })
                                    .catch(function (err) {

                                        $exceptionHandler(err);

                                        return utils.showErrorToast();
                                    });
                            });
                        }
                    }
                ];
            }
            else {
                $scope.bulk.bulkMenuItems = [
                    {
                        label: $translate.instant('Find email addresses'),
                        handler: function () {

                            const creditsText = $translate.instant('This will use up to {{count}} lead credits.', {
                                count: entityCountObject.selectedCount
                            });

                            const confirm = $mdDialog.confirm()
                                .clickOutsideToClose(true)
                                .escapeToClose(true)
                                .title($translate.instant('Are you sure?'))
                                .htmlContent(`
                                <p>
                                    ${creditsText}
                                    <br>
                                    ${$translate.instant('Salesflare will only search an email address if a contact name and account website are specified.')}
                                    <br>
                                    ${$translate.instant('You\'ll get a notification when Salesflare is done looking for emails.')}
                                </p>
                                `)
                                .ok($translate.instant('I\'m sure'))
                                .cancel($translate.instant('cancel'));

                            return $mdDialog.show(confirm).then(function () {

                                return bulkService.findEmailsForContacts(getBulkOptions())
                                    .then(function () {

                                        return $state.reload();
                                    })
                                    .catch(function (err) {

                                        $exceptionHandler(err);

                                        return utils.showErrorToast();
                                    });
                            });
                        }
                    },
                    {
                        label: $translate.instant('Send new workflow'),
                        handler: () => {

                            return $state.go('composeWorkflow', {
                                filter: getBulkOptions(true)
                            });
                        }
                    },
                    {
                        label: $translate.instant('Add to existing workflow'),
                        handler: () => {

                            return $mdDialog.show({
                                controllerAs: 'vm',
                                fullscreen: !$mdMedia('gt-sm'),
                                multiple: true,
                                clickOutsideToClose: true,
                                escapeToClose: true,
                                onShowing: (scope, element) => {

                                    element.children('md-dialog').addClass('add-to-workflow-dialog');
                                },
                                locals: {
                                    showConfirmationDialog: true
                                },
                                templateUrl: 'app-ajs/components/workflows/workflow/addcontacttoworkflowdialog/addContactToWorkflowDialog.html',
                                controller: 'AddContactToWorkflowDialogController',
                                bindToController: true
                            }).then((result) => {

                                if (result.workflow) {
                                    return workflowService.addToIndividualRecordFilter(result.workflow.id, getBulkOptions()).then(() => {
                                        $state.reload();
                                    });
                                }
                            });
                        }
                    }
                ];
            }
        }
    }
})();
